
import Vue from 'vue'
import { Mixin } from 'vue-mixin-decorator'
import { ObserveVisibility } from 'vue-observe-visibility'
import { Prop } from 'vue-property-decorator'

import { log } from '@/log'

import { columnNameToIndexMap } from '../../../../store/modules/searchContactLens/functions'

Vue.directive('observe-visibility', ObserveVisibility)

@Mixin
export default class SearchSysItemCommon extends Vue {
  @Prop()
  row: string[]

  @Prop({ default: false })
  lazyLoading: boolean

  show: boolean = false

  created() {
    // lazy loadがONならば初期は非表示
    // lazy loadがOFFならば初期から表示
    this.show = !this.lazyLoading
  }

  /**
   * レンズ検索では大量の商品を表示するためブラウザのレンダリングパフォーマンスが悪化することがある。
   * その対応として初期表示量を制限し、残りはスクロールで画面に入った際に表示するようにした。
   *
   * @see https://github.com/my-color/growthpalette-front/issues/7706#issuecomment-1806714102
   *
   * TODO:
   * こういった対処自体は通常の商品一覧のオートロードでも実装されているので、本来であればItemListContainerを使う、または汎用化して利用するべき。
   * ただし、2023/11時点ではレンズ検索はGrowthPalette Frontの中でかなり独立した実装をされており、
   * 簡単に通常の商品一覧とレンズ検索で共通で利用できるオートロードコンポーネントを実装できるかもわからず、
   * ひとまずレンズ検索内で独自実装することを選択した。
   */
  visibilityChanged(isVisible: boolean) {
    // すでに表示されていたら何もしない
    if (this.show) {
      return
    }

    // 画面外に出ても何もしない
    if (!isVisible) {
      return
    }

    this.show = true
  }

  get isMP4() {
    return this.movieUrl.match('mp4')
  }

  get movieUrl() {
    return this.row[columnNameToIndexMap['movieUrl']]
  }

  get fkuUrl() {
    return this.row[columnNameToIndexMap['fkuUrl']]
  }

  get imageUrl() {
    return this.row[columnNameToIndexMap['imageUrl']]
  }

  get lensUrl() {
    return this.row[columnNameToIndexMap['lensUrl']]
  }

  get simpleProductName() {
    return this.row[columnNameToIndexMap['simpleProductName']]
  }

  get colorName() {
    return this.row[columnNameToIndexMap['colorName']]
  }

  get period() {
    return this.row[columnNameToIndexMap['period']]
  }

  get bc() {
    return this.row[columnNameToIndexMap['bc']]
  }

  get dia() {
    return this.row[columnNameToIndexMap['dia']]
  }

  get coloringdia() {
    return this.row[columnNameToIndexMap['coloringdia']]
  }

  get price() {
    const num = Number(this.row[columnNameToIndexMap['price']])

    return `${(num).toLocaleString()}円(税込)`
  }

  get spDrawing() {
    return this.row[columnNameToIndexMap['spDrawing']]
  }

  playMovie() {
    this.$emit('playMovie')

    log.debug('playMovie')
    log.debug(this.movieUrl)
    const video = $('#search_sys_body_menu_sp_modal2_movie')
    video.attr('src', this.movieUrl)
    const videolink = $('#search_sys_body_menu_sp_modal2_movie_link')
    videolink.attr('href', this.fkuUrl)

    video.get(0)['load']()
    video.get(0)['play']()

    $('#logo-animation__loader').show()
    video.get(0).addEventListener('loadeddata', () => {
      $('#logo-animation__loader').hide()
      log.debug('load finish')
    })
  }
}
